var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-skeleton",class:{ 'app-skeleton--inline': _vm.inline }},_vm._l((_vm.count),function(n){return _c('v-skeleton-loader',_vm._b({key:n,staticClass:"app-skeleton__item",attrs:{"type":_vm.type,"tile":_vm.tile,"boilerplate":_vm.boilerplate}},'v-skeleton-loader',_vm.$attrs,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }